export enum ModeloIzzaGPTActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_MODELO = "ATUALIZAR_MODELO",
}

export type ModeloIzzaGPTActionModel =
    | { type: ModeloIzzaGPTActionsTypes.CARREGAR; payload: string }
    | { type: ModeloIzzaGPTActionsTypes.ATUALIZAR_MODELO; payload: string }
